import script from "./ChatPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatPage.vue?vue&type=script&setup=true&lang=ts"

import "./ChatPage.vue?vue&type=style&index=0&id=2998929c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2998929c"]])

export default __exports__